// extracted by mini-css-extract-plugin
export default {"block":"LoginForm_block__iTucR","link":"LoginForm_link__JW94h"};